var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWarningIcon = function SvgWarningIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F73A54",
    d: "M2.901 12.826 3.135.086H.873l.234 12.74zm-.936 5.486c.91 0 1.69-.65 1.69-1.56 0-.936-.78-1.612-1.69-1.612-.884 0-1.638.676-1.638 1.612 0 .91.754 1.56 1.638 1.56"
  })));
};
export default SvgWarningIcon;